import { apiRequest } from "../../../utils/apiFunction";
export default async function signOut(_, { getState }) {
  const { memberDetails } = getState();

  await apiRequest({
    url: "/user/logout",
    method: "GET",
    headers: {
      Authorization:
        sessionStorage.getItem("authToken") || memberDetails.authToken,
      "Content-Type": "application/json",
    },
  });
}
